module.exports = __webpack_public_path__ + "static/media/9.e6a43a46.jpg";